import { fg } from '@atlaskit/platform-feature-flags';
import getDocument from './getDocument';
var mediaApiPathPrefix = '/media-api';
function getRelativeUrl(absoluteUrl) {
  var url = new URL(absoluteUrl);
  return "".concat(url.pathname).concat(url.search).concat(url.hash);
}
export function isPathBasedEnabled() {
  var _getDocument;
  var isLocalhost = ((_getDocument = getDocument()) === null || _getDocument === void 0 || (_getDocument = _getDocument.location) === null || _getDocument === void 0 ? void 0 : _getDocument.hostname) === 'localhost';
  return fg('platform_media_path_based_route') && !isLocalhost;
}
export function mapToPathBasedUrl(url) {
  if (isPathBasedEnabled()) {
    var _getDocument2;
    var parsedUrl = new URL(url);
    if (!parsedUrl.pathname.startsWith(mediaApiPathPrefix)) {
      parsedUrl.pathname = "".concat(mediaApiPathPrefix).concat(parsedUrl.pathname);
    }
    var location = (_getDocument2 = getDocument()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.location;

    // in this case we are most likely in SSR / a non browser environment so just return a relative URL
    if (!location) {
      return getRelativeUrl(parsedUrl.toString());
    }
    parsedUrl.host = location.host;
    return parsedUrl.toString();
  }
  return url;
}
export function mapRetryUrlToPathBasedUrl(url) {
  var _getDocument$location, _getDocument3;
  var parsedUrl = new URL(url);
  parsedUrl.host = (_getDocument$location = (_getDocument3 = getDocument()) === null || _getDocument3 === void 0 ? void 0 : _getDocument3.location.host) !== null && _getDocument$location !== void 0 ? _getDocument$location : '';

  // remove CDN from the URL for retry if it exists
  var pathname = parsedUrl.pathname;
  if (pathname.endsWith('/cdn')) {
    parsedUrl.pathname = pathname.replace('/cdn', '');
  }
  if (!parsedUrl.pathname.startsWith(mediaApiPathPrefix)) {
    parsedUrl.pathname = "".concat(mediaApiPathPrefix).concat(parsedUrl.pathname);
  }
  return parsedUrl;
}